import React from 'react';
import { Link } from 'react-router-dom';
import { openPrivacyChoices } from '../utils/consent';

export default function Footer() {
  return (
    <footer className="bg-bg border-t border-white/10 px-4 py-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-white/60 text-sm">
          <p>© {new Date().getFullYear()} GenAnything. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link 
              to="/privacy" 
              className="hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms" 
              className="hover:text-white transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/refund-policy"
              className="hover:text-white transition-colors"
            >
              Refund Policy
            </Link>
            {/* CCPA/CPRA opt-out surface — replaces an interruptive banner.
                Opens the Cookiebot "Your Privacy Choices" dialog. */}
            <button
              type="button"
              onClick={openPrivacyChoices}
              className="hover:text-white transition-colors bg-transparent border-0 p-0 m-0 cursor-pointer text-white/60 text-sm font-[inherit]"
            >
              Your Privacy Choices
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

